export const Section = ({ eyebrow, title, intro, testid, center = false }) => (
  <div className={`mb-10 sm:mb-14 ${center ? "text-center mx-auto max-w-3xl" : "max-w-3xl"}`} data-testid={testid}>
    {eyebrow && (
      <p className="mb-3 text-xs font-bold uppercase tracking-[0.28em] text-terracotta">{eyebrow}</p>
    )}
    <h2 className="font-serif text-3xl font-semibold leading-tight tracking-tight text-ink text-balance sm:text-4xl lg:text-5xl">
      {title}
    </h2>
    {intro && <p className="mt-4 text-base leading-relaxed text-ink-muted sm:text-lg">{intro}</p>}
  </div>
);
